module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img3.2a98228b23a9925b171a111e23c9af0c.jpg";